import { useEffect, useRef, useState } from 'react';
export const useElementVisibility = (options) => {
    const elementRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(function handleVisibilityChange() {
        const element = elementRef.current;
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            setIsVisible(entry.isIntersecting);
        }, options ?? { threshold: 0.1 });
        if (element) {
            observer.observe(element);
        }
        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [options]);
    return { elementRef, isVisible };
};
